import { createSlice } from "@reduxjs/toolkit";

const paginationDataSlice = createSlice({
  name: "pagination",
  initialState: [],
  reducers: {
    setData: (state, action) => {
      return action.payload;
    },
  },
});

export const { setData } = paginationDataSlice.actions;
export const paginationData = paginationDataSlice.reducer;
